/**
 * Extracts the WorkDrive resource ID from a WorkDrive URL or raw resource ID.
 * Example URL: "https://workdrive.zoho.com.au/folder/ltsu330deac83a5cd43e196dd279bd2c6062d"
 * Extracted ID: "ltsu330deac83a5cd43e196dd279bd2c6062d"
 */
export function extractWorkdriveResourceId(url?: string | null): string {
  if (!url) return "";
  const cleanUrl = url.split("?")[0].split("#")[0].replace(/\/+$/, "");
  const lastSegment = cleanUrl.substring(cleanUrl.lastIndexOf("/") + 1).trim();
  return lastSegment;
}

export function buildWorkdriveFormData(
  moduleName: string,
  fields: object,
  trigger?: string[],
  files?: File[],
): FormData {
  const formData = new FormData();
  formData.append("module", moduleName);
  formData.append("fields", JSON.stringify(fields));

  if (trigger?.length) {
    formData.append("trigger", JSON.stringify(trigger));
  }

  files?.forEach((file) => formData.append("files", file, file.name));
  return formData;
}
